import { render, staticRenderFns } from "./InquiryDetailCommentImage.vue?vue&type=template&id=ab3979c6&scoped=true&"
import script from "./InquiryDetailCommentImage.vue?vue&type=script&lang=js&"
export * from "./InquiryDetailCommentImage.vue?vue&type=script&lang=js&"
import style0 from "./InquiryDetailCommentImage.vue?vue&type=style&index=0&id=ab3979c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3979c6",
  null
  
)

export default component.exports